var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 78,
    viewBox: "0 0 201 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.549 64.832H19.453c-3.566 0-6.484-2.918-6.484-6.484V19.445c0-3.566 2.918-6.484 6.484-6.484h162.096c3.567 0 6.484 2.918 6.484 6.484v38.903c0 3.566-2.917 6.484-6.484 6.484z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.549 13.995a5.446 5.446 0 0 1 5.447 5.446v38.903a5.446 5.446 0 0 1-5.447 5.447H19.453a5.446 5.446 0 0 1-5.447-5.447V19.441a5.446 5.446 0 0 1 5.447-5.446h162.096zm0-1.038H19.453c-3.566 0-6.484 2.918-6.484 6.484v38.903c0 3.566 2.918 6.484 6.484 6.484h162.096c3.567 0 6.484-2.918 6.484-6.484V19.441c0-3.566-2.917-6.484-6.484-6.484z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.461 26.245c0 1.09-.324 1.958-.972 2.594-.727.765-1.686 1.154-2.853 1.154-1.128 0-2.075-.39-2.866-1.167-.791-.778-1.18-1.75-1.18-2.892 0-1.154.389-2.114 1.18-2.892.79-.778 1.738-1.167 2.866-1.167.557 0 1.09.104 1.595.324.506.22.908.506 1.219.869l-.688.687c-.518-.61-1.219-.92-2.126-.92-.817 0-1.53.285-2.127.868-.596.571-.895 1.323-.895 2.244 0 .92.299 1.673.895 2.243.597.57 1.31.87 2.127.87.869 0 1.595-.286 2.178-.87.376-.376.597-.908.649-1.582h-2.827v-.934h3.773c.026.195.052.39.052.571zM80.441 23.01h-3.54v2.464h3.19v.934H76.9v2.464h3.54v.96h-4.539V22.05h4.54v.96zM84.654 29.831h-.999v-6.82h-2.178v-.96h5.342v.96h-2.178v6.82h.013zM90.695 29.831v-7.78h.999v7.78h-.999zM96.13 29.831h-.998v-6.82h-2.179v-.96h5.343v.96h-2.179v6.82h.013zM108.425 28.813c-.765.79-1.712 1.18-2.853 1.18-1.141 0-2.088-.39-2.853-1.18-.765-.791-1.141-1.75-1.141-2.88 0-1.127.376-2.1 1.141-2.878.765-.791 1.712-1.18 2.853-1.18 1.128 0 2.075.389 2.853 1.18.765.791 1.154 1.75 1.154 2.879-.013 1.141-.389 2.1-1.154 2.879zm-4.967-.649c.571.584 1.284.87 2.114.87.83 0 1.543-.286 2.114-.87.571-.583.869-1.322.869-2.23 0-.908-.286-1.647-.869-2.23-.571-.584-1.284-.87-2.114-.87-.83 0-1.543.286-2.114.87-.57.583-.868 1.322-.868 2.23 0 .908.298 1.647.868 2.23zM110.98 29.831v-7.78h1.219l3.787 6.056h.039l-.039-1.505v-4.551h.999v7.78h-1.038l-3.955-6.34h-.039l.039 1.503v4.837h-1.012z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.33 41.177c-3.047 0-5.537 2.321-5.537 5.511 0 3.177 2.49 5.511 5.537 5.511 3.048 0 5.537-2.334 5.537-5.51 0-3.19-2.489-5.512-5.537-5.512zm0 8.857c-1.673 0-3.112-1.375-3.112-3.346 0-1.984 1.44-3.346 3.112-3.346 1.673 0 3.112 1.362 3.112 3.346 0 1.971-1.452 3.346-3.112 3.346zm-12.086-8.857c-3.047 0-5.537 2.321-5.537 5.511 0 3.177 2.49 5.511 5.537 5.511 3.048 0 5.537-2.334 5.537-5.51 0-3.19-2.49-5.512-5.537-5.512zm0 8.857c-1.673 0-3.112-1.375-3.112-3.346 0-1.984 1.44-3.346 3.112-3.346 1.673 0 3.112 1.362 3.112 3.346 0 1.971-1.439 3.346-3.112 3.346zm-14.368-7.158v2.334h5.602c-.169 1.31-.61 2.282-1.27 2.944-.818.816-2.089 1.711-4.32 1.711-3.449 0-6.146-2.775-6.146-6.224 0-3.45 2.697-6.225 6.147-6.225 1.854 0 3.216.726 4.214 1.673l1.647-1.647c-1.4-1.336-3.255-2.36-5.874-2.36-4.72 0-8.689 3.838-8.689 8.572 0 4.72 3.969 8.571 8.689 8.571 2.554 0 4.474-.83 5.978-2.399 1.543-1.543 2.023-3.721 2.023-5.472 0-.545-.039-1.05-.13-1.465h-7.871v-.013zm58.757 1.815c-.454-1.232-1.855-3.514-4.721-3.514-2.839 0-5.2 2.23-5.2 5.511 0 3.087 2.335 5.511 5.473 5.511 2.529 0 3.994-1.543 4.59-2.438l-1.88-1.257c-.622.92-1.478 1.53-2.71 1.53s-2.114-.57-2.672-1.673l7.379-3.047-.259-.623zm-7.522 1.842c-.064-2.127 1.647-3.216 2.879-3.216.96 0 1.777.48 2.049 1.167l-4.928 2.049zm-5.991 5.342h2.425v-16.21h-2.425v16.21zm-3.968-9.466h-.091c-.544-.649-1.582-1.232-2.904-1.232-2.762 0-5.291 2.425-5.291 5.537 0 3.086 2.529 5.498 5.291 5.498 1.309 0 2.36-.583 2.904-1.257h.078v.79c0 2.114-1.128 3.242-2.943 3.242-1.479 0-2.399-1.063-2.776-1.958l-2.113.882c.609 1.465 2.217 3.255 4.889 3.255 2.84 0 5.239-1.673 5.239-5.745v-9.907h-2.296v.895h.013zm-2.788 7.625c-1.673 0-3.073-1.4-3.073-3.32 0-1.945 1.4-3.358 3.073-3.358 1.647 0 2.944 1.426 2.944 3.358.013 1.92-1.284 3.32-2.944 3.32zm31.628-14.368h-5.796v16.21h2.425v-6.148h3.384c2.685 0 5.317-1.945 5.317-5.03 0-3.087-2.658-5.032-5.33-5.032zm.052 7.806h-3.436V37.91h3.436c1.816 0 2.84 1.504 2.84 2.775 0 1.27-1.024 2.788-2.84 2.788zm14.965-2.321c-1.751 0-3.566.778-4.318 2.477l2.153.895c.453-.895 1.309-1.194 2.204-1.194 1.245 0 2.529.753 2.542 2.088v.169c-.441-.246-1.375-.623-2.529-.623-2.321 0-4.668 1.271-4.668 3.644 0 2.166 1.893 3.566 4.02 3.566 1.621 0 2.528-.726 3.086-1.581h.078v1.257h2.334v-6.211c.013-2.88-2.14-4.487-4.902-4.487zm-.298 8.883c-.791 0-1.893-.402-1.893-1.375 0-1.245 1.374-1.724 2.567-1.724 1.064 0 1.569.233 2.205.544-.182 1.492-1.479 2.555-2.879 2.555zm13.72-8.533-2.775 7.029h-.078l-2.879-7.029h-2.607l4.319 9.83-2.464 5.459h2.529l6.652-15.289h-2.697zm-21.786 10.374h2.425v-16.21h-2.425v16.21z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.507 22.737c-.376.402-.597 1.025-.597 1.816v28.684c0 .804.22 1.427.597 1.816l.09.09L42.664 39.09V38.7L26.597 22.646l-.09.091z",
    fill: "url(#6zfxfk64la)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m48.02 44.448-5.356-5.356v-.389l5.356-5.355.116.065 6.342 3.605c1.815 1.024 1.815 2.71 0 3.747l-6.342 3.605-.116.078z",
    fill: "url(#neb8755ttb)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48.138 44.375-5.472-5.473L26.508 55.06c.596.636 1.582.713 2.697.078l18.933-10.763z",
    fill: "url(#pokjwbd45c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.14 33.425 29.192 22.662c-1.115-.635-2.1-.557-2.697.078l16.17 16.158 5.473-5.473z",
    fill: "url(#0q4w0qoj3d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.021 44.256 29.192 54.954c-1.05.597-1.997.558-2.593.013l-.091.091.09.09c.61.545 1.544.584 2.594-.012l18.946-10.763-.117-.117z",
    fill: "#000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M26.507 54.872c-.376-.402-.597-1.024-.597-1.815v.194c0 .804.22 1.427.597 1.816l.09-.091-.09-.104zM54.479 40.588l-6.471 3.67.116.117 6.342-3.605c.907-.519 1.361-1.193 1.361-1.868-.064.61-.518 1.22-1.348 1.686z",
    fill: "#000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M29.192 22.845 54.48 37.213c.817.467 1.284 1.064 1.362 1.686 0-.674-.454-1.361-1.362-1.867L29.192 22.664c-1.815-1.025-3.294-.17-3.294 1.906v.194c0-2.087 1.492-2.943 3.294-1.919z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6zfxfk64la",
    x1: 41.238,
    y1: 24.254,
    x2: 19.475,
    y2: 46.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neb8755ttb",
    x1: 56.843,
    y1: 38.9,
    x2: 25.466,
    y2: 38.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pokjwbd45c",
    x1: 45.164,
    y1: 41.88,
    x2: 15.652,
    y2: 71.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0q4w0qoj3d",
    x1: 22.434,
    y1: 13.191,
    x2: 35.612,
    y2: 26.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ca2943a472ced96e1df6b49a9217292b.svg";
export { ForwardRef as ReactComponent };